import { en, type Translations } from "../../i18n/en";
import type { CalendarViewKey } from "../../navigation/calendarViews";

/**
 * Each view's name as the switcher says it, read by the switcher, the phone's options and the rail alike, so one
 * view has one name. Defaulted name by name from English: the harnesses hand partial tables.
 */
export function calendarViewLabels(t: { drafts?: Partial<Translations["drafts"]> }): Record<CalendarViewKey, string> {
    const drafts = t.drafts ?? {};
    return {
        reservations: drafts.viewReservations ?? en.drafts.viewReservations,
        minStay: drafts.viewMinStay ?? en.drafts.viewMinStay,
        delta: drafts.metricDelta ?? en.drafts.metricDelta,
        occupancy: drafts.metricOccupancy ?? en.drafts.metricOccupancy,
        demand: drafts.metricDemand ?? en.drafts.metricDemand,
        market: drafts.metricMarket ?? en.drafts.metricMarket,
        compset: drafts.metricCompset ?? en.drafts.metricCompset,
    };
}
